import { useMemo } from 'react';

export default function ArticleTemplate({ article, renderSections }) {
  const date = useMemo(() => {
    const options = {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    };
    return new Date(
      article.publishedAt || article.createdAt
    ).toLocaleDateString('en-US', options);
  }, [article.createdAt, article.publishedAt]);

  return (
    <div data-comp={ArticleTemplate.displayName} className="py-contained">
      <div className="px-contained mb-8 flex flex-col items-center gap-3 text-center md:mb-10">
        <p className="text-sm md:text-base">
          {article.author ? `${article.author} | ` : ''}
          {date}
        </p>

        <h1 className="text-title-h2 max-w-[60rem]">{article.title}</h1>

        {article.category && (
          <p className="btn-text flex h-8 items-center justify-center rounded-full bg-lightGray px-4 text-text">
            {article.category}
          </p>
        )}
      </div>

      {renderSections()}
    </div>
  );
}

ArticleTemplate.displayName = 'ArticleTemplate';
